export default __webpack_public_path__ + "static/media/build.5b841e25.jpg";